import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formattedDateTime } from "../../Util/UtilHelper";
import MUITypography from "../../Components/MUITypography";
import { align_center, align_row } from "../../Styles/VMStyles";
import { ROUTE_VISITOR_LOG } from "../../Util/VMConstants";

const VisitorsReminders = ({ data = [] }) => {
  const navigate = useNavigate();
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <Card variant="outlined" sx={{ borderRadius: 3 ,pt:2,minHeight: '170px',pl:2,minWidth:'250px' }}>
        <MUITypography variant="h4" gutterBottom sx={{fontWeight:700}}>
          Visitor Reminders
        </MUITypography>
       
        <CardContent sx={{ textAlign: "center"}}>
               <Box sx= {{...align_center,...align_row,width:'100%',height:'100%',flexDirection:'column',gap:2 }}>
              
                           <Box
                                        component="img"
                                        src={'/static/visitor.png'}
                                        alt="Task"
                                        sx={{
                                          mt:5,
                                          height: { xs: 50, md: 50 },
                                        }}
                                      />
                        <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1,mb:1 }}>
                          No Pending Visitors.
                        </Typography>
                     
                        </Box>      
        </CardContent>
      </Card>
    );
  }

  const total = data[0]?.total_pending_visitors_count ?? 0;

  return (
    <Card variant="outlined" sx={{ borderRadius: 3 ,p:2,minHeight: '400px'}}>
      <CardContent>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2} mt={2}
        >
      <MUITypography variant="h4" gutterBottom sx={{fontWeight:700}}>
          Visitor Reminders
        </MUITypography>
          <Chip
            label={`Total Pending: ${total}`}
            color="primary"
            variant="outlined"
            size="small"
          />
        </Box>

        {/* Visitors Table */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "primary.main" }}>
                {["Visitor", "Date",  "Type"].map((head) => (
                  <TableCell
                    key={head}
                    sx={{ color: "white", fontWeight: 600 }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, i) => (
                <TableRow
                  key={row.id ?? i}
                  onClick={() => navigate("/" + ROUTE_VISITOR_LOG)}
                  sx={{
                    bgcolor: i % 2 === 1 ? "#F9FBFF" : "white",
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "action.hover",
                    },
                  }}
                >
                  {/* Visitor */}
                  <TableCell>
                    <Typography fontWeight={500}>{row.name}</Typography>
                  </TableCell>

                  {/* Date */}
                  <TableCell>{formattedDateTime(row.created_date)}</TableCell>

                  
                  {/* Purpose */}
                  <TableCell>{row.type}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default VisitorsReminders;
